import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { SideNavConsumer } from '../context/SideNavContext';
import NavToggle from './NavToggle';

const Container = styled.nav<{ open: boolean }>`
  position: fixed;
  left: 0;
  top: 59px;
  background: #4694ce;
  color: white;
  height: 100%;
  font-size: 0.95rem;
  min-width: 3.125rem;
  overflow: ${s => (s.open ? 'hidden' : 'visible')};
  width: ${s => (s.open ? '15.6rem' : '3.125rem')};
  will-change: transform, width;
  transition: width 250ms ease;
  z-index: 20;
`;

const NavList = styled.div`
  display: flex;
  flex-direction: column;
`;

interface Props {
  children: ReactNode;
}

const NavPanel = (props: Props) => {
  return (
    <SideNavConsumer>
      {({ state }) => (
        <Container data-testid="nav-panel-container" open={state.isSideNavOpen}>
          <NavToggle />
          <NavList>{props.children}</NavList>
        </Container>
      )}
    </SideNavConsumer>
  );
};

export default NavPanel;
export { NavPanel };
